
import { mapActions, mapState } from 'vuex'
export default {
  data () {
    return {
      openmobilenav: false,
      subnav: false,
      activeItem: 'home',
      activeChildItem: 'fashion 1',
      activemegaChild: 'portfolio'
    }
  },
  async fetch () {
    await this.fetchShopCategories()
    await this.fetchBlogCategories()
  },
  fetchOnServer: false,
  computed: {
    ...mapState({
      menulist: state => state.menu.data
    })
  },
  methods: {
    ...mapActions({
      fetchShopCategories: 'menu/fetchShopCategories',
      fetchBlogCategories: 'menu/fetchBlogCategories'
    }),
    mobilenav () {
      this.openmobilenav = !this.openmobilenav
    },
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      menuItem.active = true
    },
    isActiveChild (menuChildItem) {
      return this.activeChildItem === menuChildItem
    },
    setActiveChild (menuChildItem) {
      if (this.activeChildItem === menuChildItem) {
        this.activeChildItem = ''
      } else {
        this.activeChildItem = menuChildItem
      }
    },
    isActivesubmega (megaChildItem) {
      return this.activemegaChild === megaChildItem
    },
    setActivesubmega (megaChildItem) {
      if (this.activemegaChild === megaChildItem) {
        this.activemegaChild = ''
      } else {
        this.activemegaChild = megaChildItem
      }
    }
  }
}
